<template>
  <div class="h-full modal w-full">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        Details zu E-Mail-Funnels
      </h1>
      <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
        <table class="w-full text-sm mt-4">
          <tbody class="text-gray-800">
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                insgesamt versendete Mails
              </td>
              <td class="text-right font-medium">
                {{ emailSentCountsStatistics?.sent?.toLocaleString() || 0 }}
              </td>
            </tr>
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                gesendet in den letzten 30 Tagen
              </td>
              <td class="text-right font-medium">
                {{ emailSentCountsStatistics?.lastThirtyDaysSent?.toLocaleString() || 0 }}
              </td>
            </tr>
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                nicht zugestellt
              </td>
              <td class="text-right font-medium">
                {{ totalBounces?.toLocaleString() || 0 }}
              </td>
            </tr>
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                soft bounces
              </td>
              <td class="text-right font-medium">
                {{ emailBounceStatistics?.softBounce || 0 }}
              </td>
            </tr>
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                hard bounces
              </td>
              <td class="text-right font-medium">
                {{ emailBounceStatistics?.hardBounce || 0 }}
              </td>
            </tr>
            <tr class="border-t border-gray-200">
              <td
                class="py-2"
              >
                Automatisch beantwortete E-Mails
              </td>
              <td class="text-right font-medium">
                {{ emailAutoReplyStatistics?.totalCount?.toLocaleString() || 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="$emit('close')"
      >
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import EMAIL_FUNNELS_AUTO_REPLY_STATISTICS from '@/components/company/queries/GetCompanyAutoReply.gql'
import EMAIL_FUNNELS_BOUNCE_STATISTICS from '@/components/company/queries/GetCompanyEmailFunnelsBounceStatistics.gql'
import EMAIL_FUNNELS_SENT_COUNTS_STATISTICS from '@/components/company/queries/GetCompanyEmailFunnelsSentCounts.gql'

export default {
  props: {
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      totalBounces: 0
    }
  },
  apollo: {
    emailBounceStatistics: {
      query: EMAIL_FUNNELS_BOUNCE_STATISTICS,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      skip () {
        return !this.companyId
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.emailBounceStatistics) {
          const soft = data.emailBounceStatistics?.softBounce || 0
          const hard = data.emailBounceStatistics?.hardBounce || 0
          this.totalBounces = soft + hard

          return data.emailBounceStatistics
        }
        return []
      }
    },
    emailSentCountsStatistics: {
      query: EMAIL_FUNNELS_SENT_COUNTS_STATISTICS,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      skip () {
        return !this.companyId
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.emailSentCountsStatistics) {
          return data.emailSentCountsStatistics
        }
        return []
      }
    },
    emailAutoReplyStatistics: {
      query: EMAIL_FUNNELS_AUTO_REPLY_STATISTICS,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      skip () {
        return !this.companyId
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.emailAutoReplyStatistics) {
          return data.emailAutoReplyStatistics
        }
        return []
      }
    }
  }
}
</script>
<style scoped>
.table-wrapper table {
  height: auto;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
}
.table-wrapper {
  flex: 0 0 100%;
}

</style>
